/**
 * Shared OxboAuthClient instance.
 *
 * `getAccessToken` is wired to the tokenStore so authenticated calls pick up
 * the current password-login token. For the SSO/cookie flow the store is empty
 * and the client falls back to cookie auth (the SDK sets `credentials: "include"`).
 */
import { OxboAuthClient } from "@oxbo/auth-client";
import { env } from "../config/env";
import { tokenStore } from "./tokenStore";

export const authClient = new OxboAuthClient({
  baseUrl: env.authApiUrl,
  getAccessToken: () => tokenStore.getAccessToken(),
});
